import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

const AGB = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="agb-page">
      {/* Hero Section */}
      <section className="bg-[#003B7A] py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <FileText className="w-12 h-12 text-[#FFD700] mx-auto mb-4" />
            <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
              Allgemeine Geschäftsbedingungen
            </h1>
            <p className="text-gray-300 text-lg">Marali Immobilien AG</p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-24">
        <div className="max-w-[900px] mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">1. Geltungsbereich</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") der Marali Immobilien AG (nachfolgend „Marali Immobilien") gelten für sämtliche Dienstleistungen und Produkte, die von Marali Immobilien angeboten werden. Mit der Inanspruchnahme unserer Dienstleistungen oder dem Kauf unserer Produkte erklären Sie sich mit diesen AGB einverstanden. Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, Marali Immobilien hat diesen ausdrücklich schriftlich zugestimmt.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">2. Dienstleistungen</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Marali Immobilien bietet Dienstleistungen in den Bereichen Immobilienverwaltung und Bauarbeiten an. Der genaue Umfang der Leistungen wird in individuellen Verträgen oder Offerten festgelegt. Marali Immobilien behält sich das Recht vor, die angebotenen Dienstleistungen jederzeit anzupassen oder einzustellen.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">3. Zustandekommen des Vertrages</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Ein Vertrag zwischen dem Kunden und Marali Immobilien kommt durch die schriftliche Annahme einer Offerte von Marali Immobilien durch den Kunden oder durch die schriftliche Bestätigung eines Auftrages durch Marali Immobilien zustande.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">4. Preise und Zahlungsbedingungen</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Die Preise für die Dienstleistungen und Produkte von Marali Immobilien werden in der jeweiligen Offerte oder im Vertrag festgelegt. Alle Preise verstehen sich, sofern nicht anders angegeben, in Schweizer Franken (CHF) und exklusive Mehrwertsteuer. Rechnungen sind innert 30 Tagen nach Rechnungsdatum ohne Abzug zahlbar. Bei Zahlungsverzug ist Marali Immobilien berechtigt, Verzugszinsen sowie Mahngebühren zu erheben.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">5. Pflichten des Kunden</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Der Kunde ist verpflichtet, Marali Immobilien alle für die Erbringung der Dienstleistung notwendigen Informationen und Unterlagen vollständig und fristgerecht zur Verfügung zu stellen. Der Kunde ist für die Richtigkeit und Vollständigkeit dieser Informationen verantwortlich.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">6. Haftung</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Marali Immobilien haftet für direkte Schäden, die durch grobe Fahrlässigkeit oder Vorsatz von Marali Immobilien verursacht wurden. Die Haftung für leichte Fahrlässigkeit wird, soweit gesetzlich zulässig, ausgeschlossen. Die Haftung für indirekte Schäden, Folgeschäden, entgangenen Gewinn oder Datenverlust wird in jedem Fall ausgeschlossen. Die maximale Haftung von Marali Immobilien ist auf den Wert des jeweiligen Auftrages begrenzt.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">7. Gewährleistung</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Marali Immobilien gewährleistet eine sorgfältige und fachgerechte Ausführung der vereinbarten Dienstleistungen. Mängel sind Marali Immobilien unverzüglich nach deren Entdeckung schriftlich mitzuteilen. Marali Immobilien hat das Recht zur Nachbesserung. Schlägt die Nachbesserung fehl, hat der Kunde Anspruch auf Minderung oder Rücktritt vom Vertrag.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">8. Datenschutz</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Marali Immobilien verpflichtet sich, die Bestimmungen des schweizerischen Datenschutzgesetzes (DSG) einzuhalten. Persönliche Daten werden vertraulich behandelt und nur für die Erbringung der Dienstleistungen verwendet. Eine Weitergabe an Dritte erfolgt nur mit ausdrücklicher Zustimmung des Kunden oder wenn dies gesetzlich vorgeschrieben ist.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">9. Geistiges Eigentum</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Alle Rechte an geistigem Eigentum, die im Rahmen der Erbringung der Dienstleistungen entstehen, verbleiben bei Marali Immobilien, sofern nicht anders schriftlich vereinbart.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">10. Vertraulichkeit</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Beide Parteien verpflichten sich, alle nicht öffentlich bekannten Informationen, die sie im Rahmen der Zusammenarbeit erhalten, vertraulich zu behandeln.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">11. Änderungen der AGB</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Marali Immobilien behält sich das Recht vor, diese AGB jederzeit zu ändern. Änderungen werden dem Kunden schriftlich oder auf andere geeignete Weise mitgeteilt und gelten als akzeptiert, wenn der Kunde den Änderungen nicht innert 30 Tagen widerspricht.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">12. Salvatorische Klausel</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder werden, so wird die Gültigkeit der übrigen Bestimmungen dadurch nicht berührt. Die unwirksame Bestimmung ist durch eine wirksame Bestimmung zu ersetzen, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
            </p>

            <h2 className="text-2xl font-bold text-[#003B7A] mb-4">13. Anwendbares Recht und Gerichtsstand</h2>
            <p className="text-gray-700 mb-8 leading-relaxed">
              Diese AGB unterliegen schweizerischem Recht. Ausschliesslicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesen AGB ist Cazis, Schweiz.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AGB;
